"use strict";

var PyDefUtils = require("PyDefUtils");

module.exports = function(pyModule) {

	pyModule["DesignTextArea"] = Sk.misceval.buildClass(pyModule, ($gbl, $loc) => {

        $loc["__init__"] = PyDefUtils.funcFastCall((args, kwargs) => {
            const self = args[0];
            // Disable auto-resize in designer
            self._anvil.updateDesignName = updateDesignName;
            self._anvil.updatedTextProp = self._anvil.getPropJS("text") ?? "";
            self._anvil.updatedPlaceholderProp = self._anvil.getPropJS("placeholder") ?? "";
            self._anvil.element.css("height", self._anvil.taHeight);
            self._anvil.elements.outer.style.resize = "none";
            PyDefUtils.addHeightHandle(self._anvil);
        });
        
    }, 'DesignTextArea', [pyModule["TextArea"]]);


    function updateDesignName(s) {
        const textProp =
            "updatedTextProp" in s._anvil ? s._anvil.updatedTextProp : s._anvil.componentSpec && s._anvil.componentSpec.properties["text"];
        const placeholderProp =
            "updatedPlaceholderProp" in s._anvil
                ? s._anvil.updatedPlaceholderProp
                : s._anvil.componentSpec && s._anvil.componentSpec.properties["placeholder"];
        const e = s._anvil.element;
        if (!s._anvil.inlineEditing && !textProp && !placeholderProp) {
            e.addClass("anvil-designer-empty-component-message");
            e.val(s._anvil.designName);
            e.attr("placeholder", null);
        } else {
            e.removeClass("anvil-designer-empty-component-message");
            e.val(textProp);
            e.attr("placeholder", placeholderProp);
        }
    }

    // currently this overrides TextArea.prototype._anvilClassic$propMap 
    pyModule["DesignTextArea"].prototype._anvilClassic$propMap["text"].set = (s,e,v) => {
        s._anvil.updatedTextProp = v.toString();
        updateDesignName(s)
    };
    pyModule["DesignTextArea"].prototype._anvilClassic$propMap["text"].get = undefined;

    pyModule["DesignTextArea"].prototype._anvilClassic$propMap["placeholder"].set = (s,e,v) => {
        s._anvil.updatedPlaceholderProp = v.toString();
        updateDesignName(s);
    }
    pyModule["DesignTextArea"].prototype._anvilClassic$propMap["placeholder"].get = undefined;

};
